import React from 'react';
import Page from './page';

function HTZAPolicy() {
    return (
        <Page label="Bundu — Legal" title="Privacy Policy">
            <div className="doc">
                <p>Privacy policy coming soon.</p>
            </div>
        </Page>
    );
}

export default HTZAPolicy;
